module.exports = __webpack_public_path__ + "static/media/appen.99b4973a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/appen.jpg
// module id = 1500
// module chunks = 0